import NokoFilter from './NokoFilter.vue';

export default NokoFilter;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/filter/index.ts